import '../assets/NcLoadingIcon-BSONDy7x.css';
import { openBlock, createElementBlock, createElementVNode, toDisplayString, createCommentVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcLoadingIcon",
  props: {
    /**
     * Specify the size of the loading icon.
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * The appearance of the loading icon.
     * 'auto' adjusts to the Nextcloud color scheme,
     * 'light' and 'dark' are static.
     */
    appearance: {
      type: String,
      validator(value) {
        return ["auto", "light", "dark"].includes(value);
      },
      default: "auto"
    },
    /**
     * Specify what is loading.
     */
    name: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const colors = ["#777", "#CCC"];
      if (this.appearance === "light") {
        return colors;
      } else if (this.appearance === "dark") {
        return colors.reverse();
      }
      return ["var(--color-loading-light)", "var(--color-loading-dark)"];
    }
  }
};
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["width", "height"];
const _hoisted_3 = ["fill"];
const _hoisted_4 = ["fill"];
const _hoisted_5 = { key: 0 };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    "aria-label": $props.name,
    role: "img",
    class: "material-design-icon loading-icon"
  }, [
    (openBlock(), createElementBlock("svg", {
      width: $props.size,
      height: $props.size,
      viewBox: "0 0 24 24"
    }, [
      createElementVNode("path", {
        fill: $options.colors[0],
        d: "M12,4V2A10,10 0 1,0 22,12H20A8,8 0 1,1 12,4Z"
      }, null, 8, _hoisted_3),
      createElementVNode("path", {
        fill: $options.colors[1],
        d: "M12,4V2A10,10 0 0,1 22,12H20A8,8 0 0,0 12,4Z"
      }, [
        $props.name ? (openBlock(), createElementBlock("title", _hoisted_5, toDisplayString($props.name), 1)) : createCommentVNode("", true)
      ], 8, _hoisted_4)
    ], 8, _hoisted_2))
  ], 8, _hoisted_1);
}
const NcLoadingIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-551209a3"]]);
export {
  NcLoadingIcon as N
};
